<template>
  <div class="action-config-item">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <el-button @click="openRefreshEntityConfigureModal()" type="text" icon="el-icon-s-tools">
      Configure
    </el-button>
    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
    <dialog-component
      :visible="entityRefreshModal"
      :title="'Refresh Entity Tables'"
      @before-close="resetRefreshEntityConfigureTemplate"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      :isShowFooter="false"
    >
      <div class="mt-1 mb-1">
        <el-row>
          <el-link
            type="primary"
            icon="el-icon-plus"
            class="float-right"
            :underline="false"
            @click="addRefreshEntity()"
          >
            Add entity
          </el-link>
        </el-row>
        <el-scrollbar wrap-style="max-height: 60vh;">
          <el-row v-for="(entity, i) in entityRefreshList" :key="i + '_refresh_entity'">
            <el-select
              v-model="entity.entity_from"
              placeholder="Take entity from"
              @change="(changedValue) => getEntityDetails(changedValue, entity)"
              clearable
              filterable
              size="medium"
            >
              <el-option-group label="Relational"></el-option-group>
              <el-option-group label="Entity fields">
                <el-option
                  v-for="(field, i) in getFieldsByType(['ENTITY'], allFieldsWithDataTable)"
                  :key="field + i"
                  :value="field.key"
                  :label="field.label"
                ></el-option>
              </el-option-group>
            </el-select>
            <el-select
              v-if="entity.entity_id"
              v-model="entity.update_field"
              placeholder="Refresh entity"
              clearable
              filterable
            >
              <el-option
                v-for="(field, index) in (actionEntityFields[entity.entity_id] || []).filter((e) =>
                  checkAutofillEntityData(e)
                )"
                :key="field + index"
                :value="field.key"
                :label="field.label"
                :disabled="
                  entityRefreshList.find((en, j) => field.key == en.update_field && j !== i)
                    ? true
                    : false
                "
              ></el-option>
            </el-select>
            <el-link
              type="danger"
              :underline="false"
              icon="el-icon-delete"
              @click="entityRefreshList.splice(i, 1)"
            ></el-link>
          </el-row>
        </el-scrollbar>
      </div>
    </dialog-component>
  </div>
</template>

<script>
  import StepEditableMixin from './StepEditableMixin';
  import templateBuilderHelper from '../../../../mixins/templateBuilderHelper';
  import { mapGetters } from 'vuex';
  export default {
    name: 'RefreshEntityAction',
    props: {
      step: Object,
      allEntities: Array,
      currentEntity: Object,
    },
    mixins: [StepEditableMixin, templateBuilderHelper],
    data() {
      return {
        entityRefreshList: [],
        entityRefreshModal: false,
        allFieldsWithDataTable: [],
      };
    },
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile', 'getIsRSOpen']),
    },
    mounted() {
      (this.allEntities || []).forEach((entity) => {
        this.actionEntityFields[entity._id] = this.getAllFieldsFromEntity(
          entity,
          false,
          false,
          true
        );
      });
      this.allFieldsWithDataTable = this.getAllFieldsFromEntity(
        this.currentEntity,
        true,
        true,
        true
      );
    },
    methods: {
      openRefreshEntityConfigureModal() {
        (this.allEntities || []).forEach((entity) => {
          this.actionEntityFields[entity._id] = this.getAllFieldsFromEntity(entity, false);
        });
        this.entityRefreshList = this.localStep.entity_refresh_list || [];
        this.entityRefreshModal = true;
      },
      resetRefreshEntityConfigureTemplate() {
        this.$set(this.localStep, 'entity_refresh_list', this.entityRefreshList);
        this.entityRefreshList = [];
        this.entityRefreshModal = false;
      },
    },
  };
</script>
<style scoped>
  .action-config-item {
    background-color: #f9fafb; /* subtle card background */
    border: 1px solid #e5e7eb; /* light border */
    border-radius: 8px;
    padding: 1rem;
    font-family:
      'Inter',
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      'Helvetica Neue',
      Arial,
      sans-serif;
    color: #374151;
  }

  .action-config-item .el-button,
  .action-config-item .el-link {
    font-size: 0.95rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
  }

  .action-config-item .el-button {
    border-radius: 6px;
    background-color: #2563eb;
    color: white;
    padding: 0.35rem 0.75rem;
    transition: background-color 0.2s;
  }

  .action-config-item .el-button:hover {
    background-color: #1d4ed8;
  }

  .action-config-item .el-link {
    margin-left: 0.5rem;
  }

  .action-config-item .el-link.float-right {
    float: right;
  }

  .action-config-item .el-link[type='danger'] {
    color: #dc2626;
  }

  .action-config-item .el-link[type='danger']:hover {
    color: #b91c1c;
  }

  .el-select .el-input__inner {
    border-radius: 6px;
  }

  .el-select .el-select-dropdown__item:hover {
    background-color: #eff6ff;
  }

  .el-scrollbar {
    max-height: 60vh;
    margin-top: 0.5rem;
    padding-right: 0.25rem;
  }

  .el-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .el-row .el-select {
    flex: 1;
  }
</style>
